/**
 * Normalizes GET …/nusuk-cards-batchs/returns/:id (edit/show) payloads where the
 * return row may include nested `batch` and nullable `entity_details`.
 */

export function unwrapReturnPayload(data) {
  return data?.data?.data ?? data?.data ?? null;
}

export function mergeReturnRow(row) {
  if (!row) return null;
  const batch = row.batch ?? row.nusuk_cards_batch ?? {};
  return {
    ...batch,
    ...row,
    batch,
    entity_details: row.entity_details ?? batch.entity_details ?? null,
    batch_no: row.batch_no ?? batch.batch_no,
    group_name: row.group_name ?? batch.group_name,
    card_no: row.card_no ?? batch.card_no,
    campaign_id: row.campaign_id ?? batch.campaign_id,
  };
}

export function pickCampaignOrGroupNumber(row) {
  const n =
    row?.entity_details?.number ??
    row?.batch?.entity_details?.number ??
    row?.campaign_id ??
    row?.batch?.campaign_id;
  if (n === null || n === undefined || n === "") return "-";
  return String(n);
}

export function pickCampaignOrGroupName(row, getLocalizedText) {
  return (
    getLocalizedText(
      row?.entity_details?.name_ar ?? row?.batch?.entity_details?.name_ar,
      row?.entity_details?.name_en ?? row?.batch?.entity_details?.name_en
    ) ||
    row?.entity_details?.name ||
    row?.batch?.entity_details?.name ||
    row?.campaign_name ||
    "-"
  );
}

export function pickServiceCenter(row, getLocalizedText) {
  return (
    getLocalizedText(
      row?.entity_details?.service_center?.name_ar ??
        row?.batch?.entity_details?.service_center?.name_ar,
      row?.entity_details?.service_center?.name_en ??
        row?.batch?.entity_details?.service_center?.name_en
    ) ||
    row?.entity_details?.service_center?.name ||
    row?.batch?.entity_details?.service_center?.name ||
    "-"
  );
}

export function pickNationality(row, getLocalizedText) {
  return (
    getLocalizedText(
      row?.entity_details?.nationality?.name_ar ??
        row?.batch?.entity_details?.nationality?.name_ar,
      row?.entity_details?.nationality?.name_en ??
        row?.batch?.entity_details?.nationality?.name_en
    ) ||
    row?.entity_details?.nationality?.name ||
    row?.batch?.entity_details?.nationality?.name ||
    "-"
  );
}

export function pickOrganizer(row, getLocalizedText) {
  return (
    getLocalizedText(
      row?.entity_details?.organizer?.name_ar ??
        row?.batch?.entity_details?.organizer?.name_ar,
      row?.entity_details?.organizer?.name_en ??
        row?.batch?.entity_details?.organizer?.name_en
    ) ||
    row?.entity_details?.organizer?.name ||
    row?.batch?.entity_details?.organizer?.name ||
    row?.organizer_name ||
    "-"
  );
}

/** Default values for the return edit form (reason list + API row). */
export function deriveReturnFormDefaults(row, returnReasons, getLocalizedText) {
  const representative_name = String(
    row.representative_name ?? row.recipient_name ?? ""
  );
  const notes = row.notes != null && row.notes !== "" ? String(row.notes) : "";

  let reason_id;
  const directId =
    row.reason_id !== undefined && row.reason_id !== null && row.reason_id !== ""
      ? row.reason_id
      : row.return_reason_id ??
        row.reason_details?.id ??
        row.reason_detail?.id;
  if (directId != null && directId !== "") {
    reason_id = directId;
  } else if (returnReasons?.length) {
    const text = String(
      row.reason ?? row.return_reason ?? row.reason_text ?? ""
    ).trim();
    if (text) {
      const found = returnReasons.find((r) => {
        const id = r.id ?? r.value;
        const label =
          getLocalizedText(r.name_ar, r.name_en) ||
          r.name ||
          r.title ||
          r.reason ||
          "";
        return (
          String(label).trim() === text ||
          String(r.reason ?? "").trim() === text ||
          String(id) === text
        );
      });
      reason_id = found ? (found.id ?? found.value) : undefined;
    } else {
      reason_id = undefined;
    }
  } else {
    reason_id = undefined;
  }

  return {
    reason_id: reason_id ?? undefined,
    representative_name,
    notes,
  };
}
